<template>
<div style="min-height: 100%;">
  <HeaderView></HeaderView>
  <NavigateView></NavigateView>
  <BannerView></BannerView>
  <div v-bind:style="{minHeight: height+'px'}" style="width: 1000px;margin: 0 auto;" >
    <el-steps style="padding-top:40px; width: 950px; " :active="active" finish-status="success" align-center>
      <el-step title="账户设置" icon="el-icon-user-solid"></el-step>
      <el-step title="基本信息填写" icon="el-icon-s-home"></el-step>
      <el-step title="证照上传" icon="el-icon-picture" description="仅支持jpg/jpeg/gif/png/bmp/pdf"></el-step>
      <el-step title="产品报名" icon="el-icon-info"></el-step>
    </el-steps>
    <!--background-color: #f8f8f8;-->
    <div v-if="active===0" class="register-wrapper-div">
      <el-form :disabled="registerInvalid" @submit.native.prevent style="width: 550px; margin: 0 auto;" label-position="right" label-width="150px" status-icon key="loginAccount" :rules="loginAccountRules" :model="loginAccount" ref="loginAccount">
        <el-form-item label="">
          <el-col :span="24" style="text-align: left; margin: 10px 0">
            <el-alert title="提示信息：" left :closable="false" type="info" show-icon v-if="!registerInvalid">
              报名分为账户注册、产品报名两个环节，请按提示操作。
            </el-alert>
            <el-alert title="提示信息：" left :closable="false" type="warning" show-icon v-if="registerInvalid">
              账号注册已截止!
            </el-alert>
          </el-col>
        </el-form-item>
        <el-form-item label="账户名" prop="username">
          <el-input v-model="loginAccount.username" placeholder="由6到14位的中文、字母或数字组成" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码"  prop="password">
          <el-input v-model="loginAccount.password" placeholder="请输入6-20位密码" autocomplete="off" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码"  prop="checkPass">
          <el-input v-model="loginAccount.checkPass" placeholder="请再次输入密码"  autocomplete="off" show-password></el-input>
        </el-form-item>
      </el-form>
      <el-button :loading="submitButtonLoading" style="margin: 20px 0;" @click="goLogin">返回登录</el-button>
      <el-button :loading="submitButtonLoading" type="primary" style="margin: 20px 0;" @click="next('loginAccount')" v-if="!registerInvalid">下一步</el-button>
    </div>

    <div v-if="active===1" class="register-wrapper-div">
      <el-form @submit.native.prevent style="text-align: left; margin: 30px" label-position="right" label-width="150px" status-icon key="companyInfo" :rules="companyInfoRules" :model="companyInfo" ref="companyInfo" :disabled="registerInvalid">
        <el-row type="flex">
          <el-col :span="24">
            企业信息
            <el-divider></el-divider>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col :span="24">
            <el-alert title="  进口药品全国总代理请填写国内代理企业社会统一社会信用代码，企业信息选择「进口药品全国总代理」为‘是’。" left :closable="false" type="info" show-icon></el-alert>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col :span="12">
            <el-form-item label="企业注册类型"  prop="companyType">
              <el-select v-model="companyInfo.companyType" placeholder="请选择" style="width: 200px">
                <el-option
                  v-for="item in companyTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="进口药品全国总代理/药品上市许可持有人" label-width="280" prop="agent" v-if="companyInfo.companyType === 1">
              <el-radio-group v-model="companyInfo.agent">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row type="flex">
          <el-col :span="12">
            <el-form-item label="统一社会信用代码" prop="zzjgdm">
              <el-input v-model="companyInfo.zzjgdm" placeholder="请输入18位统一社会信用代码" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
          <el-row type="flex">
            <el-col :span="12">
              <el-form-item label="企业名称"  prop="companyName">
                <el-input v-model="companyInfo.companyName" maxlength="200" placeholder="请输入企业名称" autocomplete="off">
                </el-input>
              </el-form-item>
            </el-col>
            <el-form-item label="法定代表人"  prop="attr_qyfrxm">
              <el-input v-model="companyInfo.attr_qyfrxm" placeholder="同营业执照中的法定代表人" autocomplete="off" style="width: 200px"></el-input>
            </el-form-item>
          </el-row>

        <el-row type="flex">
          <el-col :span="24">
            联系人(被授权人)信息
            <el-divider></el-divider>
          </el-col>
        </el-row>

          <el-row type="flex">
            <el-col :span="12">
              <el-form-item label="联系人(被授权人)"  prop="attr_lxr">
                <el-input v-model="companyInfo.attr_lxr" placeholder="请输入一位联系人(被授权人)" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-form-item label="所属部门和职务">
              <el-input v-model="companyInfo.departments" placeholder="请输入所属部门和职务" autocomplete="off"></el-input>
            </el-form-item>
          </el-row>

          <el-row type="flex">
            <el-col :span="12">
              <el-form-item label="身份证号" prop="idNumber">
                <el-input v-model="companyInfo.idNumber" placeholder="请输入联系人身份证号" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
              <el-form-item label="联系电话"  prop="phone">
                <el-input v-model="companyInfo.phone" placeholder="请输入联系电话" autocomplete="off"></el-input>
              </el-form-item>
          </el-row>

          <el-row type="flex">
            <el-col :span="12">
              <el-form-item label="电子邮箱"  prop="email">
                <el-input v-model="companyInfo.email" placeholder="请输入电子邮箱" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <el-button :loading="submitButtonLoading" style="margin: 20px 0;" @click="previous" v-if="!registerInvalid">上一步</el-button>
        <el-button :loading="submitButtonLoading"  type="primary" style="margin: 20px 0;" @click="next('companyInfo')" v-if="!registerInvalid">下一步</el-button>
      </div>

      <div v-if="active===2" class="register-wrapper-div">
        <el-form @submit.native.prevent style="width: 760px; margin: 30px auto" label-position="right" label-width="400px" status-icon key="qyzzUpload" :rules="qyzzUploadRules" :model="qyzzUpload" ref="qyzzUpload" :disabled="registerInvalid">
        <el-form-item label="营业执照" prop="yyzzImg">
          <el-upload
            class="upload-left"
            :action="uploadImgUrl"
            :on-preview="handlePreview"
            :before-remove="beforeRemove"
            :on-remove="handleRemoveyyzzImg"
            :multiple="false"
            :limit="1"
            :on-exceed="handleExceed"
            :before-upload="beforeFileUpload"
            :on-success="handleSuccessyyzzImg"
            :on-error="handleError"
            :file-list="fileListyyzzImg"
            >
            <el-button :loading="submitButtonLoading" size="small" type="primary">上传营业执照</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item :label="qyzzUpload.ypscImgName" prop="ypscImg">
          <el-upload
            class="upload-left"
            :action="uploadImgUrl"
            :on-preview="handlePreview"
            :before-remove="beforeRemove"
            :on-remove="handleRemoveypscImg"
            :multiple="false"
            :limit="1"
            :on-exceed="handleExceed"
            :before-upload="beforeFileUpload"
            :on-success="handleSuccessypscImg"
            :on-error="handleError"
            :file-list="fileListypscImg"
          >
            <el-button :loading="submitButtonLoading" size="small" type="primary">{{qyzzUpload.ypscImgName}}</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="法定代表人授权证书" prop="fddbrsqzsImg">
          <el-upload
            class="upload-left"
            :action="uploadImgUrl"
            :on-preview="handlePreview"
            :before-remove="beforeRemove"
            :on-remove="handleRemovefddbrsqzsImg"
            :multiple="false"
            :limit="1"
            :on-exceed="handleExceed"
            :before-upload="beforeFileUpload"
            :on-success="handleSuccessfddbrsqzsImg"
            :on-error="handleError"
            :file-list="fileListfddbrsqzsImg"
          >
            <el-button :loading="submitButtonLoading" size="small" type="primary">上传法定代表人授权证书</el-button>
          </el-upload>
        </el-form-item>

        <el-row type="flex">
          <el-col :span="18">
            <el-form-item label="验证码"  prop="captcha">
              <el-input v-model="qyzzUpload.captcha"
                        placeholder="请输入验证码"
                        autocomplete="off"
                        autocapitalize="off"
                        spellcheck="false"
              ></el-input>
            </el-form-item>
          </el-col>
            <img ref="captcha" style="width: 100px; height: 55px" :src="captchaUrl" @click="changCaptcha" />
        </el-row>

        <!-- <el-row type="flex">
          <el-col :span="24">
            <el-form-item  prop="zcxy">
              <label  slot="label">
                <el-checkbox v-model="qyzzUpload.zcxy">
                </el-checkbox>
              </label>
              <div style="text-align: left;line-height: 20px;">
                <el-link type="primary" target="_blank" :href="zcxyUrl">《注册协议》</el-link>
                <br/>
                <label @click="qyzzUpload.zcxy=!qyzzUpload.zcxy" style="cursor:pointer;">
                  我已阅读并同意相关服务条款和隐私政策
                </label>
              </div>
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>

      <el-button :loading="submitButtonLoading" style="margin: 20px 0;" @click="previous" v-if="!registerInvalid">上一步</el-button>
      <el-button :loading="submitButtonLoading" type="primary" style="margin: 20px 0;" @click="submitForm('qyzzUpload')" v-if="!registerInvalid">提交</el-button>
    </div>

      <div v-if="active===3" class="register-wrapper-div">
        <el-row type="flex">
          <el-col :span="24">
          <span style="font-size: 75px;font-weight: bold; padding: 20px;line-height: 80px;">
            <i class="el-icon-success" style="color:#52C41A;"></i>
          </span>
          </el-col>
        </el-row>
        <div style="font-size: 24px;color: #333;font-weight: 500;margin-top: 30px;">
          您的账号已注册成功！
        </div>

        <div style="font-size: 14px;color: #666;margin: 10px 100px; text-align: left;">
          <el-col :span="24" style="text-align: left; margin: 10px;">
            <el-alert title="信息提示：" left :closable="false" type="info" show-icon>
              1. 请使用您的注册账号登录，并选择“集中议价”中的“在线报名”功能，对本企业可供应的联盟医疗机构在用药品进行报名，参与本次药品集团采购和集中议价。<br>
              2. 您的企业注册信息及报名产品信息，将由联盟工作人员进行后台审核。审核结果将发送至您的注册邮箱，请注意查收。<br>
              3. 审核通过后完成所有报名环节工作，您可对已报名产品进行网上资料填报。<br>
              4. 如您有任何疑问，可通过“集中议价”中的“业务答疑”功能进行问题登记，随后将由联盟工作人员与您联系。<br>
            </el-alert>
          </el-col>
        </div>
        <el-button :loading="submitButtonLoading" style="margin: 20px 0;" @click="goLogin" type="primary">返回登录，开始产品报名</el-button>
      </div>
    </div>

    <el-dialog :visible.sync="dialogImageVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
    <FooterView></FooterView>
  </div>
</template>
<script>


  export default {
    name: 'step-register',
    data() {
      var checkPass =(rule, value, callback) => {
        if (value !== this.loginAccount.password) {
          callback(new Error(rule.message));
        } else {
          callback();
        }
      };
      var zcxyCheck =(rule, value, callback) => {
        if(!value){
          callback(new Error(rule.message));
        } else {
          callback();
        }
      };
      //统一社会信用代码
      var zzjgdmUnique =(rule, value, callback) => {
        this.submitButtonLoading = true;
        this.$api.registerApi.zzjgdmUnique({'zzjgdm':value}).then(response => {
          this.submitButtonLoading = false;
          if (response.status === 200) {
            if (response.data.code === 200) {
              callback();
            } else {
              callback(new Error(response.data.msg));
            }
          } else {
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      };
      //账户名
      var usernameUnique =(rule, value, callback) => {
        this.submitButtonLoading = true;
        this.$api.registerApi.usernameUnique2({'username':value}).then(response => {
          this.submitButtonLoading = false;
          if (response.status === 200) {
            if (response.data.code === 200) {
              callback();
            } else {
              callback(new Error(response.data.msg));
            }
          } else {
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      };
      //企业名称
      var companyNameUnique =(rule, value, callback) => {
        this.submitButtonLoading = true;
        this.$api.registerApi.companyNameUnique2({'companyName':value}).then(response => {
          this.submitButtonLoading = false;
          if (response.status === 200) {
            if (response.data.code === 200) {
              callback();
            } else {
              callback(new Error(response.data.msg));
            }
          } else {
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      };
      //验证码
      var captchaUnique =(rule, value, callback) => {
        this.submitButtonLoading = true;
        this.$api.registerApi.captchaValidate({'captcha':value}).then(response => {
          this.submitButtonLoading = false;
          if(response.status === 200){
            if(response.data.code === 200){
              callback();
            }else{
              callback(new Error(response.data.data));
            }
          }else{
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      };
      return {
        active: 0,
        height: 0,
        registerInvalid: false,
        submitButtonLoading: false,
        dialogImageVisible: false,
        dialogPdfVisible: false,
        dialogImageUrl: '',
        dialogPdfUrl: null,
        pdfPage : 1,
        pageCount: 0,
        captchaUrl: '',
        zcxyUrl: '', //注册协议
        uploadImgUrl: '', //图片上传
        companyTypes: [
          {
            value:1,
            label:'生产企业'
          },
          {
            value:2,
            label:'经营企业'
          }
        ],
        loginAccount: {
          //zzjgdm: '', //统一社会信用代码
          username: '', //账户名
          password: '', //密码
          checkPass: '' //确认密码
        },
        companyInfo: {
          zzjgdm: '', //统一社会信用代码
          companyType: '', //企业注册类型
          attr_shortName: '', //企业简称
          agent: undefined, //是否进口药品全国总代理
          companyName: '', //企业名称
          attr_qyfrxm: '', //法定代表人
          attr_lxr: '', //联系人(被授权人)
          departments: '', //所属部门和职务
          idNumber: '', //身份证号
          phone: '', //联系电话
          email: '' //电子邮箱
        },
        qyzzUpload: {
          yyzzImg: '', //营业执照
          ypscImg: '', //药品生产许可证 / 进口药品全国总代理 协议
          ypscImgName: '', //根据agent变化药品生产许可证 / 进口药品全国总代理 协议
          fddbrsqzsImg: '', //法定代表人授权证书
          captcha: '', //验证码
          zcxy: true //注册协议
        },
        fileListyyzzImg:[],
        fileListypscImg:[],
        fileListfddbrsqzsImg:[],
        loginAccountRules: {
          // zzjgdm: [ //远程校验唯一
          //   { required: true, message: '请输入18位统一社会信用代码', trigger: 'blur' },
          //   { min: 18, max: 18, message: '请输入18位统一社会信用代码', trigger: 'blur' },
          //   { validator:zzjgdmUnique, message: '统一社会信用代码已注册', trigger: 'blur' }
          // ],
          username: [//远程校验唯一
            { required: true, message: '账户名由6到14位的中文字符、英文字母、数字组成', trigger: 'blur' },
            { min: 6, max: 14, message: '账户名由6到14位的中文字符、英文字母、数字组成', trigger: 'blur' },
            {
              pattern: /(^[a-zA-Z0-9_\u4e00-\u9fa5]+$)/,
              message: "账户名由6到14位的中文字符、英文字母、数字组成"
            },
            { validator:usernameUnique, message: '此账户名已注册', trigger: 'blur' }

          ],
          password: [
            { required: true, message: '请输入6-20位密码', trigger: 'blur' },
            { min: 6, max: 20, message: '请输入6-20位密码', trigger: 'blur' },
            { pattern: /(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z]).{6,20}/, message: '密码中必须包含大小写字母、数字', trigger: 'blur' },

          ],
          checkPass: [
            { required: true, message: '请再次输入密码', trigger: 'blur' },
            { min: 6, max: 20, message: '请输入6-20位密码', trigger: 'blur' },
            { validator:checkPass, message: '两次输入密码不一致!', trigger: 'blur' }
          ]
        },
        companyInfoRules: {
          zzjgdm: [ //远程校验唯一
            { required: true, message: '请输入18位统一社会信用代码', trigger: 'blur' },
            { min: 18, max: 18, message: '请输入18位统一社会信用代码', trigger: 'blur' },
            { validator:zzjgdmUnique, message: '统一社会信用代码已注册', trigger: 'blur' }
          ],
          companyType: [
            { required: true, message: '请选择企业注册类型', trigger: 'blur' }
          ],
          companyName: [
            { required: true, message: '请输入企业名称', trigger: 'blur' },
            { min: 0, max: 200, message: '最大200个汉字', trigger: 'blur' },
            { validator:companyNameUnique, message: '企业名称已注册', trigger: 'blur' }
          ],
          agent: [
            { required: true, message: '请选择', trigger: 'blur' }
          ],
          attr_qyfrxm: [
            { required: true, message: '请输入法定代表人', trigger: 'blur' },
            { min: 0, max: 255, message: '最大255个汉字', trigger: 'blur' }
          ],
          attr_lxr: [
            { required: true, message: '请输入一位联系人(被授权人)', trigger: 'blur' },
            { min: 0, max: 255, message: '最大255个汉字', trigger: 'blur' }
          ],
          idNumber: [
            { required: true, message: '请输入联系人身份证号', trigger: 'blur' },
            { min: 0, max: 18, message: '最大18位', trigger: 'blur' },
            {
              pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
              message: "请输入正确的身份证号"
            }
          ],
          phone: [
            { required: true, message: '请输入联系电话', trigger: 'blur' },
            { min: 0, max: 255, message: '最大255位', trigger: 'blur' },
            {
              pattern: /((\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$)/,
              message: "请输入正确的联系电话"
            }
          ],
          email: [
            { required: true, message: '请输入电子邮箱', trigger: 'blur' },
            { min: 0, max: 255, message: '最大255位', trigger: 'blur' },
            {
              pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/,
              message: "请输入正确的电子邮箱"
            }
          ],
        },
        qyzzUploadRules: {
          yyzzImg: [
            { required: true, message: '请上传营业执照', trigger: 'blur' }
          ],
          fddbrsqzsImg: [
            { required: true, message: '请上传法定代表人授权证书', trigger: 'blur' }
          ],
          captcha: [
            { required: true, message: '请输入验证码', trigger: 'blur' }
          ],
          zcxy: [
            { validator:zcxyCheck, message: '请阅读《注册协议》', trigger: 'change' }
          ]
        }
      };
    },
    mounted(){
      //动态设置内容高度 让footer始终居底   header+footer的高度是100
      this.height = document.documentElement.clientHeight - 350;
      //监听浏览器窗口变化　
      window.onresize = ()=> {this.height = document.documentElement.clientHeight - 350};

    },
    created() {
      this.captchaUrl = this.getCaptchaUrl();
      this.zcxyUrl = process.env.VUE_APP_API_URL + 'member/register_agreement.jspx';
      this.uploadImgUrl = process.env.VUE_APP_API_URL + 'member/o_upload_image2.jspx';
      this.initView();
    },
    watch:{
      companyInfo:{
        handler(val, oldVal){
          if(1 === val.companyType){
            this.qyzzUpload.ypscImgName = val.agent === 0?'药品生产许可证':'进口药品全国总代理协议/药品上市许可持有人资质证明';
          }else if(2 === val.companyType){
            this.qyzzUpload.ypscImgName = '药品经营许可证';
          }
          let qyzzUploadRulesTemp = {
            ypscImg: [
              { required: true, message: "请上传"+this.qyzzUpload.ypscImgName, trigger: 'blur' }
            ]
          };
          Object.assign(this.qyzzUploadRules, qyzzUploadRulesTemp);
        },
        deep:true //true 深度监听
      }
    },
    methods: {
      initView(){
        setTimeout(() => {
          new Promise((resolve, reject) =>{
            return this.$api.registerApi.getRegisterInvalid({stype: 'REGISTER'}).then(data => {
              if(200 === data.status){
                if(200 === data.data.code){
                  let array = JSON.parse(data.data.data);
                  if(0 < array.length){
                    if(array[0].expiryDate && array[0].expiryDate.time < +new Date()){
                      this.registerInvalid = true;
                    }
                  }
                  resolve(true);
                }else{
                  this.$message({ message: data.data.data, offset: 200, type: 'error' });
                }
              }
              resolve(false);
            })
          }).then(res =>{
            if(res){
              this.page();
            }
          }).catch(err => {
            console.info(err);
          })
        })
      },
      changCaptcha: function() {
        this.captchaUrl = this.getCaptchaUrl();
      },
      getCaptchaUrl: function() {
        this.qyzzUpload.captcha = '';
        return process.env.VUE_APP_API_URL+'captcha.svl?d='+new Date().getTime()
      },
      previous() {
        console.log(this.fileListyyzzImg, this.loginAccount, this.companyInfo, this.qyzzUpload);
        if (this.active-- < 0) this.active = 0;
      },
      next(formName) {
        console.log(this.fileListyyzzImg, this.loginAccount, this.companyInfo, this.qyzzUpload);
        this.submitButtonLoading = true;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submitButtonLoading =  false;
            if (this.active++ > 4) this.active = 0;
          } else {
            this.submitButtonLoading =  false;
            return false;
          }
        });
      },
      submitForm(formName) {
        this.submitButtonLoading = true;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            //dosubmit
            console.log(this.loginAccount,this.companyInfo,this.qyzzUpload);
            // var json3 = JSON.parse((JSON.stringify(this.loginAccount) + JSON.stringify(this.companyInfo) + JSON.stringify(this.qyzzUpload)).replaceAll('}{', ','));
            var json3={};
            Object.assign(json3, this.loginAccount, this.companyInfo, this.qyzzUpload);
            this.$api.registerApi.doRegister(json3).then(response => {
              this.submitButtonLoading = false;
              console.log(response);
              if(response.status === 200){
                if(response.data.code === 200){
                  if (this.active++ > 4) this.active = 0;
                }else{
                  this.captchaUrl = this.getCaptchaUrl();
                  this.$message.error({message:response.data.data || `服务忙，请稍后再试`});
                }
              }else{
                this.captchaUrl = this.getCaptchaUrl();
                this.$message.error(`服务忙，请稍后再试`);
              }
            }).catch(error => {
              this.captchaUrl = this.getCaptchaUrl();
              this.submitButtonLoading = false;
            });
          } else {
            this.submitButtonLoading = false;
            return false;
          }
        });
      },
      goLogin() {
        this.submitButtonLoading = false;
        window.location.href = process.env.VUE_APP_API_URL
        // this.$router.push({path: +''});
      },
      handleRemoveyyzzImg(file, fileList) {
        console.log(file, fileList);
        this.qyzzUpload.yyzzImg = '';
        this.fileListyyzzImg = fileList.slice(0,0);
      },
      handleRemoveypscImg(file, fileList) {
        console.log(file, fileList);
        this.qyzzUpload.ypscImg = '';
        this.fileListypscImg = fileList.slice(0,0);
      },
      handleRemovefddbrsqzsImg(file, fileList) {
        console.log(file, fileList);
        this.qyzzUpload.fddbrsqzsImg = '';
        this.fileListfddbrsqzsImg = fileList.slice(0,0);
      },
      handlePreview(file) {
        console.log("handlePreview",file);
        let fileUrl = process.env.VUE_APP_BASE_URL + '/member/readflie.jspx?filePath=' + file.response.data;
        if (!fileUrl.endsWith('.pdf')) {
          this.dialogImageUrl = fileUrl;
          this.dialogImageVisible = true;
        } else {
          this.dialogPdfUrl = fileUrl;
          // this.dialogPdfUrl = pdf.createLoadingTask(fileUrl);
          // this.dialogPdfVisible = true;
          window.open(fileUrl);
        }
      },
      handleExceed(files, fileList) {
        this.$message.error(`当前限制上传 1 个文件`);
      },
      beforeFileUpload(file) {
        const supportFileType = ["jpg", "jpeg", "gif", "png", "bmp","pdf"];

        let type1 = (file.name).substring((file.name).lastIndexOf(".")+1);
        let fileExt = type1.trim().toLowerCase();

        const isSupport = supportFileType.indexOf(fileExt)>-1;
        const isLt100M = file.size / 1024 / 1024 < 100;

        if (!isSupport) {
          this.$message.error('只能上传['+supportFileType+']格式的文件!');
        }
        if (!isLt100M) {
          this.$message.error('上传文件大小不能超过 100MB!');
        }
        return isSupport && isLt100M;
      },
      handleSuccessyyzzImg(response, file, fileList) {
        if(response.code === 200){
          this.qyzzUpload.yyzzImg = response.data;
          this.fileListyyzzImg = fileList;
        }else{
          this.$message.error(response.msg);
          this.fileListyyzzImg = fileList.slice(0,0);
        }
      },
      handleSuccessypscImg(response, file, fileList) {
        if (response.code === 200) {
          this.qyzzUpload.ypscImg = response.data;
          this.fileListypscImg = fileList;
        } else {
          this.$message.error(response.msg);
          this.fileListypscImg = fileList.slice(0,0);
        }
      },
      handleSuccessfddbrsqzsImg(response, file, fileList) {
        if (response.code === 200) {
          this.qyzzUpload.fddbrsqzsImg = response.data;
          this.fileListfddbrsqzsImg = fileList;
        } else {
          this.$message.error(response.msg);
          this.fileListfddbrsqzsImg = fileList.slice(0,0);
        }
      },
      handleError(response, file, fileList) {
        this.$message.error(`上传失败，请稍后再试`);
      },
      beforeRemove(file, fileList) {
        console.log(file);
        if(file.status !== 'ready')
          return this.$confirm(`确定移除 ${ file.name }？`);
      },
      //关闭窗口初始化PDF页码
      closePdfDialog(){
        this.pdfPage = 1;
        this.dialogPdfVisible = false;
      },
      //PDF改变页数
      previousPdfPage(){
        var p = this.pdfPage
        p = p>1?p-1:this.pageCount
        this.pdfPage = p
      },
      nextPdfPage(){
        var p = this.pdfPage
        p = p<this.pageCount?p+1:1
        this.pdfPage = p
      }
    }
  }
</script>
<style>
  .el-divider--horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 12px 0;
  }
  .upload-left{
    text-align: left;
  }
  .register-wrapper-div{
    text-align: center;
    padding-top:10px;
    width: 850px;
    margin: 0 auto;
    background-color: #f8f8f8;
  }
  .el-alert .el-alert__description{
    line-height: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Register/StepRegister.vue